import { render } from "./upload-document.vue?vue&type=template&id=20266ffe&scoped=true&ts=true"
import script from "./upload-document.vue?vue&type=script&lang=ts"
export * from "./upload-document.vue?vue&type=script&lang=ts"

import "./upload-document.vue?vue&type=style&index=0&id=20266ffe&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20266ffe"]])

export default __exports__